

import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MwcCheckboxGroupComponent } from './checkbox-group.component';
import { MwcCheckboxWrapperComponent } from './checkbox-wrapper.component';
import { MwcCheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [BidiModule, CommonModule, FormsModule, A11yModule],
  declarations: [MwcCheckboxComponent, MwcCheckboxGroupComponent, MwcCheckboxWrapperComponent],
  exports: [MwcCheckboxComponent, MwcCheckboxGroupComponent, MwcCheckboxWrapperComponent]
})
export class MwcCheckboxModule {}
